import { inject } from 'aurelia';
import { websiteShortCode } from '../environment';
import { ApiService } from './api-service';

@inject(ApiService)
export class CustomerService {
    path = 'User';
    idPath = this.path + '/';

    constructor(private api: ApiService) { }

    async updateInformation(data) {
        data.websiteShortCode = websiteShortCode();
        return await this.api.doPut(this.path + '/updateInformation', data);
    }

    async requestPasswordReset(data) {
        data.websiteShortCode = websiteShortCode();
        return await this.api.doPost('requestResetPassword', data);
    }

    async destroyUserCartProducts(id = 0, orderId = 0) {
        return await this.api.doDelete(`${this.path}/${id}/DestroyUserCartProducts/${orderId}`);
    }

    async getUserCartProducts() {
        return await this.api.doGet(`${this.path}/GetUserCartProducts`);
    }

    async getUserCartProductsCount() {
        return await this.api.doGet(`${this.path}/cart/count`);
    }

    async getLatestNotifications(userId: number, page: number, pageSize: number, includeHidden: boolean, languageId: number) {
        const params: any = {
            userId: userId,
            websiteShortCode: websiteShortCode(),
            page: page,
            pageSize: pageSize,
            includeHidden: includeHidden,
            languageId: languageId
        };

        return await this.api.doGet('Notification/GetLatestNotification', params);
    }

    async markAsRead(notificationsId, state) {
        const params: any = {
            ids: notificationsId,
            state: state
        };

        return await this.api.doPost('Notification/MarkAsRead', params);
    }

    async getAllUnreadCount(userId: number) {
        const params: any = {
            userId,
            websiteShortCode: websiteShortCode()
        };

        return this.api.doGet('Notification/unreadCount', params);
    }

    async delete(notificationsId) {
        return await this.api.doDelete('Notification/Delete', notificationsId);
    }
}
